import { render, staticRenderFns } from "./list_form.vue?vue&type=template&id=a089318a&scoped=true"
import script from "./list_form.vue?vue&type=script&lang=js"
export * from "./list_form.vue?vue&type=script&lang=js"
import style0 from "./list_form.vue?vue&type=style&index=0&id=a089318a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a089318a",
  null
  
)

export default component.exports